
export default {
    methods: {
        accinc(obj){

            if(typeof obj !== 'object'){
                return "<span style='color: #999'>n/a</span>"
            }

            if(obj === null){
                return "<span style='color: #999'>n/a</span>"
            }

            if(obj.hasOwnProperty('acc_all') && obj.hasOwnProperty('inc_all') && obj.acc_all === true && obj.inc_all === true){
                return "INC & ACC"
            }
            else if (obj.hasOwnProperty('acc_all') && obj.acc_all === true){
                return "ACC"
            }
            else if (obj.hasOwnProperty('inc_all') && obj.inc_all === true){
                return "INC"
            }
            else{
                return "<span style='color: #999'>n/a</span>"
            }
        },
        isMobile() {
            if (screen.width <= 760) {
               return true
            } else {
                return false
            }
        },

    }
}
